import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

// import AFTableColumn from 'af-table-column'
// Vue.use(AFTableColumn)

import { uploadLimitSize } from './config/env'
Vue.prototype.uploadLimitSize = uploadLimitSize

import ItemLink from './components/ItemLink'
Vue.component('ItemLink', ItemLink)

import ProductLink from './components/ProductLink'
Vue.component('ProductLink', ProductLink)

import ProductDialog from './components/ProductDialog'
Vue.component('ProductDialog', ProductDialog)

import FileUpload from './components/FileUpload'
Vue.component('FileUpload', FileUpload)

import ItemStatus from './components/ItemStatus'
Vue.component('ItemStatus', ItemStatus)

import FileButton from '@/components/fileBtn'
Vue.use(FileButton)

import BaseSelect from '@/components/select/base_select'
Vue.component('BaseSelect', BaseSelect)

import UserSelect from '@/components/select/user_select'
Vue.component('UserSelect', UserSelect)

import AtmTagSelect from '@/components/select/atm_tag_select'
Vue.component('AtmTagSelect', AtmTagSelect)

import DrillWellSelect from '@/components/select/drill_well_select'
Vue.component('DrillWellSelect', DrillWellSelect)

import ItemStatusSelect from '@/components/select/item_status_select'
Vue.component('ItemStatusSelect', ItemStatusSelect)

import ProductTemplateSelect from '@/components/select/product_template_select'
Vue.component('ProductTemplateSelect', ProductTemplateSelect)

import ItemTemplateSelect from '@/components/select/item_template_select'
Vue.component('ItemTemplateSelect', ItemTemplateSelect)

import ProductMultipleSelect from '@/components/select/product_multiple_select'
Vue.component('ProductMultipleSelect', ProductMultipleSelect)

import ProductSelect from '@/components/select/product_select'
Vue.component('ProductSelect', ProductSelect)

import VideoUploader from '@/components/VideoUploader'
Vue.component('VideoUploader', VideoUploader)

import VideoPlayer from '@/components/videoPlayer'
Vue.component('VideoPlayer', VideoPlayer)

import Pagination from 'vue-pagination-2'
Vue.component('pagination', Pagination)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import VueMomentLib from "vue-moment-lib"
Vue.use(VueMomentLib);

import util from './util/index';
Vue.use(util)

import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
Vue.use(VuejsDialog, {
	okText: '确定',
	cancelText: '取消'
})

Vue.config.productionTip = false

import './permission' // permission control


import authCode from '@/util/auth_code' //权限码获取
Vue.prototype.Auth = authCode

import permission from '@/directive/permission' //权限判断
Vue.directive('permission', permission)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
